export { CompareContent } from "./compare-content";